import { Controller } from "stimulus";

/** Manages the location edit form */
export default class extends Controller {
  static targets = [
    "platformTypeToggle",
    "bigcommerceFormGroup",
    "ecomPlatformToggle",
    "ecomPlatformGroup",
    "merchantFeePercentage",
  ]

  /**
   * Connects controller and toggles ecom platform type field if location is_ecom
   * is set to true. Also toggles BigCommerce fields if location ecom_platform_type
   * column is selected as "BigCommerce"
  */
  connect() {
    this.showBigCommerceFields();
    this.hideBigCommerceFields();
    this.toggleEcomPlatformType();
  }
  /**
   * displays BigCommerce fields if ecom_platform_type is selected as BigCommerce
  */
  showBigCommerceFields() {
    this.bigcommerceFormGroupTargets.forEach((formGroup) => {
      formGroup.classList.remove("toggle-hide");
    });
  }
  /**
   * hides BigCommerce fields if ecom_platform_type is NOT selected as BigCommerce
   */
  hideBigCommerceFields() {
    this.bigcommerceFormGroupTargets.forEach((formGroup) => {
      formGroup.classList.add("toggle-hide");
    });
  }
  /**
   * if is_ecom checked and BigCommerce type then show BigCommerce group fields
   * if is_ecom checked and not BigCommerce type, then don't show BigCommerce group fields
   * if is_ecom unchecked hide ecom program type and BigCommerce group fields
   */
  toggleEcomPlatformType() {
    if (!this.hasPlatformTypeToggleTarget) return;

    const platformType = this.platformTypeToggleTarget;
    const bigcommerceSelected = platformType.options[platformType.options.selectedIndex].text == "BigCommerce";

    this.ecomPlatformGroupTargets.forEach((formGroup) => {
      if (this.ecomPlatformToggleTarget.checked) {
        formGroup.classList.remove("toggle-hide");
        if (bigcommerceSelected) {
          this.showBigCommerceFields();
        } else {
          this.hideBigCommerceFields();
        };
      } else if (!this.ecomPlatformToggleTarget.checked && bigcommerceSelected) {
        this.hideBigCommerceFields();
        formGroup.classList.add("toggle-hide");
      } else {
        formGroup.classList.add("toggle-hide");
      }
    });
  }

  validateMerchantFeePercentage() {
    const value = parseFloat(this.merchantFeePercentageTarget.value);
    const group = this._getFormGroup(this.merchantFeePercentageTarget);

    if (!group) return;

    this._resetGroupState(group);

    if (isNaN(value)) return;

    const min = parseFloat(this.merchantFeePercentageTarget.dataset.minFee);
    const max = parseFloat(this.merchantFeePercentageTarget.dataset.maxFee);

    if (value < min || value > max) {
      const message = window.acima.i18n.t("invoices.validations.amount_within_range", { min: min, max: max });

      this.updateFieldState(this.merchantFeePercentageTarget, {
        isValid: false,
        message: message,
      });
      return;
    }

    if (value > 0) {
      this.updateFieldState(this.merchantFeePercentageTarget, {
        isValid: true,
        message: "Success",
      });
    }
  }

  updateFieldState(element, { isValid, message }) {
    const group = this._getFormGroup(element);
    if (!group) return;

    this._setGroupState(group, isValid);

    const label = group.querySelector("label");
    const help = label ? label.querySelector(".help-tooltip") : null;

    if (help) {
      help.setAttribute("title", message);

      $(help).tooltip('destroy');
      $(help).tooltip();
      $(help).tooltip('show');

      setTimeout(() => {
        $(help).tooltip('hide');
      }, 2000);
    }
  }

  _getFormGroup(element) {
    return element.closest("tr.form-group") || element.closest(".form-group");
  }

  _resetGroupState(group) {
    group.classList.remove("has-success", "has-error");
  }

  _setGroupState(group, isValid) {
    group.classList.remove("has-success", "has-error");
    group.classList.add(isValid ? "has-success" : "has-error");
  }
}
